(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-xfe-home]').forEach(home => {
      if (home.dataset.xfeInitialized) return;
      home.dataset.xfeInitialized = 'true';
      const mobile = window.matchMedia('(max-width: 749px)');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      const constrained = () => Boolean(connection && (connection.saveData || /(^|-)2g$|^3g$/.test(connection.effectiveType || '') || (connection.downlink > 0 && connection.downlink < 4)));
      const networkKnown = () => Boolean(connection && (connection.effectiveType || connection.downlink > 0));
      const states = new Map();
      let preferredState = null;
      let activeState = null;
      let disposed = false;
      let pageReady = false;
      let readyFrame = 0;
      const updateButton = state => {
        const playing = !state.video.paused && !state.video.ended;
        state.panel.classList.toggle('is-playing', playing);
        state.button.setAttribute('aria-label', playing ? state.button.dataset.labelPause : state.button.dataset.labelPlay);
      };
      const sourceFor = state => mobile.matches ? state.video.dataset.mobileSrc : state.video.dataset.desktopSrc;
      const load = state => {
        const nextSource = sourceFor(state);
        if (!nextSource || state.source === nextSource) return;
        state.panel.classList.remove('is-ready');
        state.video.pause();
        state.video.src = nextSource;
        state.video.muted = true;
        state.source = nextSource;
        state.video.load();
      };
      const stop = (state, release = false) => {
        state.generation += 1;
        state.playPending = false;
        state.video.pause();
        if (release && state.source) {
          if (state.video.currentTime > 0) state.positions.set(state.source, state.video.currentTime);
          state.video.removeAttribute('src');
          state.video.load();
          state.source = '';
          state.panel.classList.remove('is-ready');
        }
        updateButton(state);
      };
      const mayPlay = state => state.visible && !document.hidden && !state.userPaused && (state.userStarted || (pageReady && state.posterReady && !reduced.matches && !constrained() && (!mobile.matches || networkKnown())));
      const sync = () => {
        if (disposed) return;
        let active = null;
        states.forEach(state => {
          if (mayPlay(state) && (!active || state.ratio > active.ratio)) active = state;
        });
        if (preferredState && mayPlay(preferredState)) active = preferredState;
        else preferredState = null;
        activeState = active;
        states.forEach(state => {
          if (state !== active) stop(state, !state.visible || document.hidden);
        });
        if (active) {
          load(active);
          if (active.source && active.video.paused && !active.playPending) {
            active.playPending = true;
            const generation = ++active.generation;
            const settled = () => {
              if (disposed || generation !== active.generation) return;
              active.playPending = false;
              updateButton(active);
            };
            const playing = active.video.play();
            if (playing && typeof playing.then === 'function') playing.then(settled, settled);
            else settled();
          }
        }
      };
      const pageLoaded = () => {
        readyFrame = window.requestAnimationFrame(() => {
          readyFrame = window.requestAnimationFrame(() => {
            pageReady = true;
            sync();
          });
        });
      };
      home.querySelectorAll('[data-xfe-campaign]').forEach(panel => {
        const video = panel.querySelector('[data-xfe-video]');
        const button = panel.querySelector('[data-xfe-toggle]');
        if (!video || !button) return;
        const poster = panel.querySelector('.xfe-campaign__poster img');
        const state = {panel, video, button, visible: false, ratio: 0, posterReady: !poster, userPaused: false, userStarted: false, source: '', positions: new Map(), generation: 0, playPending: false};
        states.set(panel, state);
        button.hidden = false;
        const posterReady = () => {
          const showPoster = () => {
            if (disposed) return;
            state.posterReady = true;
            sync();
          };
          if (poster && typeof poster.decode === 'function') poster.decode().then(showPoster, showPoster);
          else showPoster();
        };
        if (poster) {
          if (poster.complete) posterReady();
          else {
            poster.addEventListener('load', posterReady, {once: true});
            poster.addEventListener('error', posterReady, {once: true});
          }
        }
        video.addEventListener('loadedmetadata', () => {
          const position = state.positions.get(state.source);
          if (position > 0 && Number.isFinite(video.duration) && position < video.duration) video.currentTime = position;
        });
        video.addEventListener('playing', () => {
          if (disposed || activeState !== state || !mayPlay(state)) {
            stop(state, true);
            return;
          }
          panel.classList.add('is-ready');
          updateButton(state);
        });
        video.addEventListener('pause', () => updateButton(state));
        video.addEventListener('error', () => {
          panel.classList.remove('is-ready');
          state.userPaused = true;
          if (preferredState === state) preferredState = null;
          updateButton(state);
        });
        button.addEventListener('click', () => {
          if (!video.paused || state.playPending) {
            state.userPaused = true;
            if (preferredState === state) preferredState = null;
          } else {
            state.userPaused = false;
            state.userStarted = true;
            state.visible = true;
            preferredState = state;
          }
          sync();
        });
      });
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = states.get(entry.target);
          if (!state) return;
          state.ratio = entry.intersectionRatio;
          state.visible = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        });
        sync();
      }, {threshold: [0, 0.25, 0.5, 0.75, 1]}) : null;
      states.forEach(state => {
        if (observer) observer.observe(state.panel);
        else {
          state.visible = true;
          state.userPaused = true;
        }
      });
      const visibilityChange = () => sync();
      const preferenceChange = () => {
        states.forEach(state => {
          if (reduced.matches || constrained()) {
            state.userStarted = false;
            stop(state, true);
          }
        });
        sync();
      };
      const breakpointChange = () => {
        states.forEach(state => stop(state, true));
        sync();
      };
      document.addEventListener('visibilitychange', visibilityChange);
      mobile.addEventListener('change', breakpointChange);
      reduced.addEventListener('change', preferenceChange);
      if (connection && connection.addEventListener) connection.addEventListener('change', preferenceChange);
      if (document.readyState === 'complete') pageLoaded();
      else window.addEventListener('load', pageLoaded, {once: true});
      home.xfeCleanup = () => {
        disposed = true;
        if (observer) observer.disconnect();
        states.forEach(state => stop(state, true));
        document.removeEventListener('visibilitychange', visibilityChange);
        window.removeEventListener('load', pageLoaded);
        window.cancelAnimationFrame(readyFrame);
        mobile.removeEventListener('change', breakpointChange);
        reduced.removeEventListener('change', preferenceChange);
        if (connection && connection.removeEventListener) connection.removeEventListener('change', preferenceChange);
      };
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), {once: true});
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-xfe-home]').forEach(home => home.xfeCleanup && home.xfeCleanup()));
})();

